import { render, staticRenderFns } from "./ItemCheck.vue?vue&type=template&id=90f3b070&scoped=true&"
import script from "./ItemCheck.vue?vue&type=script&lang=js&"
export * from "./ItemCheck.vue?vue&type=script&lang=js&"
import style0 from "./ItemCheck.vue?vue&type=style&index=0&id=90f3b070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f3b070",
  null
  
)

export default component.exports